@if (fileId$ | async; as fileId) {
  <icz-permission-settings-table
    id="file-detail-permissions-table"
    class="h-full grow"
    tableTitle="Oprávnění ke spisu"
    [entityId]="fileId"
    [entityType]="AuthorizedEntityType.FILE"
  ></icz-permission-settings-table>
}
